import script from "./AccordionItemWithDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItemWithDropdown.vue?vue&type=script&setup=true&lang=js"

import "./AccordionItemWithDropdown.vue?vue&type=style&index=0&id=ce02bd6c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce02bd6c"]])

export default __exports__